import { gql } from '@apollo/client';

export const GET_METERINGS = gql`
  query GetMetering(
    $meteringInput: QueryMeteringInput!
    $sortBy: String
    $sortOrder: String
    $skip: Float
    $limit: Float
  ) {
    getMetering(
      meteringInput: $meteringInput
      sortBy: $sortBy
      sortOrder: $sortOrder
      skip: $skip
      limit: $limit
    ) {
      id
      createdAt
      updatedAt
      shipmentId
      shipperId
      stopId
      action
      yardId
      rate
      freeDays
      startedAt
      stoppedAt
    }
  }
`;

export const GET_METERED_ACCESSORIALS = gql`
  query GetMeteredAccessorials(
    $meteringInput: QueryMeteringInput!
    $limit: Float
    $skip: Float
    $sortOrder: String
    $sortBy: String
  ) {
    getMeteredAccessorials(
      meteringInput: $meteringInput
      limit: $limit
      skip: $skip
      sortOrder: $sortOrder
      sortBy: $sortBy
    ) {
      accessorialMeterings {
        id
        charge
        customer
        containerId
        container
        payee
        payeeType
        rate
        freeDays
        meteringStart
        meteringEnd
        units
        stopId
      }
      total
    }
  }
`;
